import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { TerminalUpdate } from "../utils/types/terminalUpdates";

export const fetchTerminalUpdates = async (portCallingsId?: string) => {
  const params: Record<string, string> = {};
  if (portCallingsId) params.port_callings_id = portCallingsId;
  const response = await axiosServices.get("/terminal-updates", { params });
  return convertToCamelCase<TerminalUpdate[]>(response.data.data);
};

export const createTerminalUpdate = async (data: Partial<TerminalUpdate>) => {
  const requestData = convertToSnakeCase(data);
  const response = await axiosServices.post("/terminal-updates", requestData);
  return convertToCamelCase<TerminalUpdate>(response.data.data);
};

export const updateTerminalUpdate = async (
  id: string,
  data: Partial<TerminalUpdate>
) => {
  const requestData = convertToSnakeCase(data);
  const response = await axiosServices.put(
    `/terminal-updates/${id}`,
    requestData
  );
  return convertToCamelCase<TerminalUpdate>(response.data.data);
};

export const deleteTerminalUpdate = async (id: string) => {
  const response = await axiosServices.delete(`/terminal-updates/${id}`);
  return { success: response?.data?.success, id };
};
